var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRegistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.007,114.35c-5.535-5.539-14.51-5.539-20.045,0L4.148,146.159c-5.531,5.539-5.531,14.506,0,20.046 l20.622,20.621l51.859-51.855L56.007,114.35z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "286.422,396.623 268.742,327.077 216.884,378.94  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.136,316.475L86.058,144.397L34.2,196.26l172.073,172.077L258.136,316.475z M87.468,166.56 l149.919,149.922l-11.784,11.78L75.684,178.348L87.468,166.56z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.662,
    y: 132.491,
    className: "st0",
    width: 29.356,
    height: 28.017
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.662,
    y: 200.693,
    className: "st0",
    width: 29.356,
    height: 28.009
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.69,
    y: 132.491,
    className: "st0",
    width: 173.056,
    height: 28.017
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.69,
    y: 200.693,
    className: "st0",
    width: 173.056,
    height: 28.009
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.598,
    y: 268.894,
    className: "st0",
    width: 141.148,
    height: 28.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M429.817,11.059H195.582c-45.32,0-82.182,36.858-82.182,82.179v32.726l30.427,30.435V93.238 c0-28.586,23.178-51.752,51.755-51.752h234.235c28.594,0,51.756,23.166,51.756,51.752v254.042h-80.097 c-23.822,0-43.124,19.318-43.124,43.132v80.101h-162.77c-28.578,0-51.755-23.166-51.755-51.752v-37.072l-6.234-1.587l6.234-6.235 v-22.202L113.4,321.239v97.522c0,45.313,36.862,82.179,82.182,82.179h162.77h12.598l8.917-8.913l123.224-123.224l8.909-8.912 v-12.61V93.238C512,47.917,475.138,11.059,429.817,11.059z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegistration);
export default __webpack_public_path__ + "static/media/icon-registration.cec4800bdd83d338c07cf9823462c3d0.svg";
export { ForwardRef as ReactComponent };